import React from 'react';
import {
  Redirect,
  withRouter
} from 'react-router-dom'
import LoginMain from './views/login/main.react.js';
import auth from './auth/auth.react.js';

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirectToReferrer: false,
    }

    this.login = this.login.bind(this)
  }

  login(formState, cb) {
    var self = this;
    auth.authenticate(formState, (err) => {
      if (!err) {
        self.props.container.forceUpdate()
        self.setState({
          redirectToReferrer: true
        })
      } else {
        cb(err)
      }
    })
  }

  render() {
    const {
      from
    } = this.props.location.state || {
      from: {
        pathname: '/'
      }
    }
    const {
      redirectToReferrer,
      prompt
    } = this.state

    if (redirectToReferrer) {
      return (
        <Redirect to={from} />
      )
    }

    return (
      <LoginMain prompt={prompt} from={from} onLogin={this.login} />
    )
  }
}

Login.defaultProps = {
  container: null
}

export default withRouter(Login)



// WEBPACK FOOTER //
// ./src/login.react.js